import { element, getCanvasTargetFromDOM } from './util';

export const isModal = (target: EventTarget | null): boolean => {
  if (!target) {
    return false;
  }

  const canvasTarget = getCanvasTargetFromDOM(target);
  if (canvasTarget && canvasTarget !== 'board') {
    return false;
  }

  const parentElement = element(target)?.parentElement;
  return !!element(parentElement)?.closest('.atlaskit-portal-container');
};
